import React, { useState, useContext, useEffect } from 'react';
import { Link } from '@reach/router';
import { postJSON } from '../RestHandler';
import { signInWithGoogle } from '../firebase';
import {
    Layout,
    Row,
    Col,
    Input,
    Checkbox,
    Button,
    Form,
    Tooltip,
    Card,
    Result,
    Spin,
    Divider
} from 'antd';

import UserContext, { UserProvider } from '../providers/UserProvider';

import {
    LockOutlined,
    UserOutlined,
    ProjectTwoTone,
    GoogleOutlined
} from '@ant-design/icons';
import Landing from '../Landing';
import { dataService } from '../dataService';
const { Header, Footer, Sider, Content } = Layout;

const SignIn = () => {
    const { setUser, setPending } = useContext(UserContext);

    async function authenticateUser(
        values,
        googleUser: firebase.auth.UserCredential
    ) {
        setPending(true);
        let response = null;
        if (googleUser) {
            response = await postJSON('api/Authenticate/googlelogin', {
                idToken: googleUser.credential.idToken,
                user: googleUser.user
            });
            values.username = googleUser.user.email;
        } else {
            response = await postJSON('api/Authenticate/login', {
                email: values.username,
                password: values.password
            });
        }

        localStorage.setItem('_auth', response.token);
        localStorage.setItem('_authExpiry', response.expiration);

        if (response && response.token) {
            let userResponse = await dataService.firestore
                .collection('users')
                .doc(values.username)
                .get();
            let tempUser = userResponse.data();
            if (tempUser) {
                tempUser.photoURL =
                    tempUser.photoURL ||
                    `https://via.placeholder.com/50?text=${tempUser.displayName.substring(
                        0,
                        1
                    )}`;
                localStorage.setItem('user', JSON.stringify(tempUser));
                setUser(tempUser);
                setPending(false);
            }
        }
    }

    const googleSubmit = async () => {
        let googleUser = await signInWithGoogle();
        authenticateUser({}, googleUser);
    };

    const onFinish = async (values) => {
        await authenticateUser(values);
    };

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <Layout>
            <Content
                style={{
                    paddingLeft: '35%',
                    paddingRight: '35%',
                    height: '100vh'
                }}
            >
                <Row
                    style={{ height: '100vh' }}
                    justify="space-around"
                    align="middle"
                >
                    <Card hoverable style={{ width: 400, height: 450 }}>
                        <h2 style={{ textAlign: 'center' }}>
                            <ProjectTwoTone /> SpareDox
                        </h2>
                        <h1 style={{ textAlign: 'center' }}>Sign in</h1>
                        <br />
                        <br />

                        <Form
                            name="normal_login"
                            className="login-form"
                            onFinish={onFinish}
                        >
                            <Form.Item
                                name="username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Username!'
                                    }
                                ]}
                            >
                                <Input
                                    prefix={
                                        <UserOutlined className="site-form-item-icon" />
                                    }
                                    placeholder="Username"
                                />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your Password!'
                                    }
                                ]}
                            >
                                <Input.Password
                                    prefix={
                                        <LockOutlined className="site-form-item-icon" />
                                    }
                                    type="password"
                                    placeholder="Password"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    style={{ width: '100%' }}
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Log in
                                </Button>
                            </Form.Item>
                            <Divider plain>Or</Divider>
                            <Form.Item>
                                <Button
                                    style={{ width: '100%' }}
                                    type="primary"
                                    icon={<GoogleOutlined />}
                                    onClick={googleSubmit}
                                >
                                    Sign in with Google
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Row>
            </Content>
        </Layout>
    );
};

export default SignIn;



// WEBPACK FOOTER //
// ./demo/src/components/SignIn.js